import {get} from 'lodash';

export class TempParameter {
    readonly tempParameterDescription: DisguiseDto.TempParameter;

    private tempParameterValue: any; // attentiona! this must be an object. otherwise we lose the reference!

    constructor(tempParameterDescription: DisguiseDto.TempParameter,
                tempParameterValue: any) {
        this.tempParameterDescription = tempParameterDescription;
        this.tempParameterValue = tempParameterValue;
    }

    public getModelValue() {
        return this.tempParameterValue;
    }

    public setModelValue(modelValue: string) {
        this.tempParameterValue = modelValue;
    }

    handleUpdate(
        currentTempParamUpdateDescription: DisguiseDto.TempParameterUpdateDescription,
        data: any
    ) {
        switch (currentTempParamUpdateDescription.updateOption) {
            case 'UPDATE_ALWAYS':
            case 'UPDATE':
                let newValueToUpdate;
                if (currentTempParamUpdateDescription.keyPath) {
                    newValueToUpdate = get(data, currentTempParamUpdateDescription.keyPath);
                } else {
                    newValueToUpdate = currentTempParamUpdateDescription.value;
                }

                this.tempParameterValue = newValueToUpdate;
                break;
            case 'UPDATE_IF_EMPTY':
                if (!this.tempParameterValue) {
                    let newValueToUpdateIfModelValueIsNotEmpty;
                    if (currentTempParamUpdateDescription.keyPath) {
                        newValueToUpdateIfModelValueIsNotEmpty =
                            get(data, currentTempParamUpdateDescription.keyPath);
                    } else {
                        newValueToUpdateIfModelValueIsNotEmpty = currentTempParamUpdateDescription.value;
                    }
                    this.tempParameterValue = newValueToUpdateIfModelValueIsNotEmpty;
                }
                break;
            default:
                break;
        }
    }

    handleIntermediateUpdateByFieldValue(
        currentTempParamUpdateDescription: DisguiseDto.TempParameterUpdateDescription,
        data: any
    ) {
        switch (currentTempParamUpdateDescription.updateOption) {
            case 'UPDATE_ALWAYS':
            case 'UPDATE':
                this.tempParameterValue = data;
                break;
            case 'UPDATE_IF_EMPTY':
                if (!this.tempParameterValue) {
                    this.tempParameterValue = data;
                }
                break;
            default:
                break;
        }
    }
}
